module.exports = __webpack_public_path__ + "img/bell-ringing-02.8af91aa4.svg";